import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=00a49168&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Contact.vue?vue&type=style&index=0&id=00a49168&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "00a49168",
  "5ca75123"
  
)

export default component.exports